import { useTranslation } from "react-i18next";

export default function PrivacyPage() {
  const { t } = useTranslation();
  const P = t("pages.privacy", { returnObjects: true });
  const sections = P.sections || [];

  return (
    <div className="min-h-screen bg-secondary pt-20" data-testid="privacy-page">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-8">{P.title}</h1>
        <div className="bg-white border border-border rounded-lg p-6 md:p-8 prose prose-primary max-w-none">
          {sections.map((s, i) => (
            <div key={i}>
              <h2>{s.h}</h2>
              {s.lead && <p>{s.lead}</p>}
              {s.list && <ul>{s.list.map((li, j) => <li key={j}>{li}</li>)}</ul>}
              {(s.p || []).map((p, j) => <p key={j}>{p}</p>)}
            </div>
          ))}
          <p className="text-sm text-muted-foreground" data-testid="privacy-fr-prevails"><em>{t("pages.frPrevails")}</em></p>
        </div>
      </div>
    </div>
  );
}
